import axios from 'axios';
import Cookies from 'js-cookie';

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

const authAxios = (options) => {
  const token = Cookies.get('token');
  return axios({
    ...options,
    baseURL: BACKEND_HOST,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const apiVerifyEmail = (token) =>
  authAxios({
    method: 'POST',
    url: '/user/verify-email',
    data: {
      token,
    },
  });

export const apiSendEmailVerificationCode = () =>
  authAxios({
    method: 'POST',
    url: '/user/generate-email-verification-token',
  });

export const apiGetUserDetails = () =>
  authAxios({
    method: 'GET',
    url: '/user/get-details',
  });

export const apiLoginUser = (email, password, token) =>
  axios({
    method: 'POST',
    baseURL: BACKEND_HOST,
    url: '/user/login',
    data: { email, password, token },
  });

export const apiRegisterUser = ({ email, password, lang, token, first_name, last_name }) =>
  axios({
    method: 'POST',
    baseURL: BACKEND_HOST,
    url: '/user/register',
    data: { email, password, lang, token, first_name, last_name },
  });

export const apiGetProducts = (orgId) =>
  authAxios({
    method: 'GET',
    url: `/product/list?org_id=${orgId}`,
  });

export const apiGetCollectionDetails = (collectionId) =>
  authAxios({
    method: 'GET',
    url: `/collection/details?category_id=${collectionId}`,
  });

export const apiGetProductDetails = (productId) =>
  authAxios({
    method: 'GET',
    url: `/product/details/${productId}`,
  });

export const apiUpdateProductSlug = (productId, urlSlug) =>
  authAxios({
    method: 'POST',
    url: `/product/${productId}/update-slug`,
    data: {
      slug: urlSlug,
    },
  });

export const apiPublishProducts = (products) =>
  authAxios({
    method: 'POST',
    url: `/product/publish`,
    data: products,
  });

export const apiUnpublishProducts = (products) =>
  authAxios({
    method: 'POST',
    url: `/product/unpublish`,
    data: products,
  });

export const apiGetOrgDetails = (orgId) =>
  authAxios({
    method: 'GET',
    url: `/org/get-details?org_id=${orgId}`,
  });

export const apiGetCollections = (orgId) =>
  authAxios({
    method: 'GET',
    url: `/collection/list?org_id=${orgId}`,
  });

export const apiGetSearchResults = (searchText, orgId) =>
  authAxios({
    method: 'GET',
    url: `/search?org_id=${orgId}&text=${searchText}`,
  });

export const apiDeactivateUser = () =>
  authAxios({
    method: 'POST',
    url: `/user/deactivate`,
  });

export const apiUpdatePassword = (password, newPassword) =>
  authAxios({
    method: 'POST',
    url: `/user/update-password`,
    data: {
      password,
      newPassword,
    },
  });

export const apiUpdateUserDetails = (firstName, lastName, email) =>
  authAxios({
    method: 'POST',
    url: `/user/update-details`,
    data: {
      firstName,
      lastName,
      email,
    },
  });

export const apiUpdateOrgDetails = (id, name, email) =>
  authAxios({
    method: 'POST',
    url: `/org/update-details`,
    data: {
      id,
      name,
      email,
    },
  });

export const apiUpdateUserRole = (orgId, userId, role) =>
  authAxios({
    method: 'POST',
    url: `/org/update-user-role`,
    data: {
      orgId,
      userId,
      role,
    },
  });

export const apiAddAnnotation = (productId, position, normal) =>
  authAxios({
    method: 'POST',
    url: `/product/add-annotation/${productId}`,
    data: {
      position,
      normal,
    },
  });

export const apiUpdateAnnotation = (annotationId, name, content) =>
  authAxios({
    method: 'POST',
    url: `/product/update-annotation/${annotationId}`,
    data: {
      name,
      content,
    },
  });

export const apiGetProductAnalytics = (productId, start, end) =>
  authAxios({
    method: 'GET',
    url: `/product/analytics/${productId}?start=${start}&end=${end}`,
  });

export const apiGetAllAnalytics = (orgId, start, end) =>
  authAxios({
    method: 'GET',
    url: `/product/all-analytics?org_id=${orgId}&start=${start}&end=${end}`,
  });

export const apiDeleteAnnotation = (annotationId) =>
  authAxios({
    method: 'POST',
    url: `/product/delete-annotation/${annotationId}`,
  });

export const apiAddUserToOrg = (orgId, userEmail, role) =>
  authAxios({
    method: 'POST',
    url: `/org/${orgId}/add-user`,
    data: {
      email: userEmail,
      role,
    },
  });

export const apiRemoveUserFromOrg = (orgId, userId) =>
  authAxios({
    method: 'POST',
    url: `/org/${orgId}/remove-user/${userId}`,
  });

export const apiUploadImage = (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('image', file);
  return authAxios({
    method: 'POST',
    url: `/other/image-upload`,
    headers: {
      'content-type': 'multipart/form-data',
    },
    data: formData,
    onUploadProgress,
  });
};
